import { useState } from 'react';
import axios from 'axios';
import ReCAPTCHA from 'react-google-recaptcha';

function EnquiryForm() {
    const [formData, setFormData] = useState({
        name: '',
        phone: '',
        city: '',
        email: '',
        projectInterest: ''
    });

    const [captchaToken, setCaptchaToken] = useState(null);
    const [formSubmitted, setFormSubmitted] = useState(false);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!captchaToken) {
            alert('Please verify the CAPTCHA');
            return;
        }

        const payload = {
            ...formData,
            captcha: captchaToken
        };

        axios.post('https://www.samriddhidevelopers.in/backend/form-handler.php', payload)
            .then(response => {
                console.log('Form submitted successfully:', response.data);
                setFormSubmitted(true);
                setFormData({
                    name: '',
                    phone: '',
                    city: '',
                    email: '',
                    projectInterest: ''
                });
                setCaptchaToken(null);
                setTimeout(() => setFormSubmitted(false), 4000);
            })
            .catch(error => {
                console.error('Error submitting the form:', error);
                alert('Something went wrong. Please try again.');
            });
    };

    return (
        <div className="hero__form">
            <form onSubmit={handleSubmit}>
                <h2>Enquire Now</h2>

                <input type="text" name="name" value={formData.name} onChange={handleInputChange} placeholder="Enter your Name" required />
                <input type="tel" name="phone" value={formData.phone} onChange={handleInputChange} placeholder="Enter your Phone Number" required />
                <input type="text" name="city" value={formData.city} onChange={handleInputChange} placeholder="Enter your City" required />
                <input type="email" name="email" value={formData.email} onChange={handleInputChange} placeholder="Enter your Email" required />

                <label htmlFor="projectInterest">Project of Interest</label>
                <select name="projectInterest" value={formData.projectInterest} onChange={handleInputChange} required>
                    <option value="">-- Select --</option>
                    <option value="tamhini">The Magestic falls@Tamhini</option>
                    <option value="vatika">Aatmabodh vatika@Donje</option>
                    <option value="sawali">sawali@Kondhanpur</option>

                    <option value="waterscape">Waterscape - Panshet, Pune</option>
                    <option value="lonavalley">Lonavalley - Lonavala Annexe</option>
                    <option value="riviera_greens">Riviera Greens - Velha</option>


                </select>

                <ReCAPTCHA
                    sitekey="6LeFlmArAAAAAG3OpN5TM6JZ6ZBq1p_mKUTCn85-"
                    onChange={setCaptchaToken}
                />

                <button type="submit" className="create-account">Submit</button>
                {formSubmitted && <p className="success-message">Form submitted successfully!</p>}
            </form>
        </div>
    );
}

export default EnquiryForm;
